/**
 * Function to display error messages based on screen resolution.
 *
 * @param {string} inputMessage - The message to display when the screen resolution is below the threshold.
 * @param {string} outputMessage - The message to display when the screen resolution is at or above the threshold.
 * @param {number} screenResolutionThreshold - The screen resolution threshold in pixels.
 *
 * @example
 * // Example of usage:
 * const message = displayMessage("This message is for small screens.", "This message is for larger screens.", 768);
 * // If the screen width is less than 768 pixels, 'message' will be the input message; otherwise, it will be the output message.
 *
 * @returns {string} The error message to display based on the screen resolution.
 *
 */

export function displayMessage(
  inputMessage: string,
  outputMessage: string,
  screenResolutionThreshold: number
): string {
  if (window.innerWidth < screenResolutionThreshold) {
    return inputMessage;
  } else {
    return outputMessage;
  }
}